/* eslint-disable prefer-rest-params */

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export function gTag(...args: any[]) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(arguments)
  console.log(`👀 gTag:`, arguments)
}
